export default "__VITE_ASSET__C0cn5aew__"